import React from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';

export default function Pagination({ currentPage, totalPages, totalEntries, itemsPerPage = 5, onPageChange }) {
  const startEntry = totalEntries === 0 ? 0 : (currentPage - 1) * itemsPerPage + 1;
  const endEntry = Math.min(currentPage * itemsPerPage, totalEntries);

  return (
    <div className="pagination-wrapper">
      <div className="pagination-info">
        Showing <span>{startEntry}</span> to <span>{endEntry}</span> of {totalEntries} entries
      </div>
      <div className="pagination-btns">
        <button 
          className="pagination-btn" 
          disabled={currentPage === 1}
          onClick={() => onPageChange(currentPage - 1)}
        >
          <ChevronLeft size={18} />
        </button>
        <div className="page-numbers">
          {[...Array(totalPages)].map((_, i) => (
            <button 
              key={i} 
              className={`page-num-btn ${currentPage === i + 1 ? 'active' : ''}`}
              onClick={() => onPageChange(i + 1)}
            >
              {i + 1}
            </button>
          ))}
        </div>
        <button 
          className="pagination-btn" 
          disabled={currentPage === totalPages || totalPages === 0}
          onClick={() => onPageChange(currentPage + 1)}
        >
          <ChevronRight size={18} />
        </button>
      </div>
    </div>
  );
}
